<template>
  <div>
    <!-- TODO: refactor markup using the data in 'menu'Secondary Menu Component -->
    <!-- {{ menu }} -->
    <ul class="text-center pl-1">
      <li v-for="(route, index) in menu" :key="index" class="list-inline-item">
       <b-button variant="primary" class="custom-primary" size="sm" :to="{name:route.routeName}">
         <b-icon :icon="route.icon"></b-icon><br/>
          <small>{{route.label}}</small>
       </b-button>
      </li>
    </ul>
  </div>
</template>

<script>
import { secondary } from '../nav'

export default {
  data () {
    return {
      menu: secondary
    }
  }
}
</script>
